const LocalStorage = {
  get: (key) => {
    const value = window.localStorage.getItem(key)
    if (value === null || value === undefined) {
      return null
    }
    try {
      return JSON.parse(value)
    } catch (error) {
      console.error('Error parsing JSON from localStorage:', error)
      return null
    }
  },
  set: (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value))
    if (key === 'user' || key === 'jwt') window.dispatchEvent(new CustomEvent('ems-session-changed', { detail: { key } }))
  },
  clear: () => {
    for (const key of ['user', 'jwt', '_id', 'intestazione']) window.localStorage.removeItem(key)
    window.dispatchEvent(new CustomEvent('ems-session-changed', { detail: { key: 'jwt' } }))
  },
  delete: (key) => {
    window.localStorage.removeItem(key)
    if (key === 'user' || key === 'jwt') window.dispatchEvent(new CustomEvent('ems-session-changed', { detail: { key } }))
  }
}

export default LocalStorage
